// extracted by mini-css-extract-plugin
module.exports = {"blueBtn":"styles--blueBtn--2eEJn","blueText":"styles--blueText--f9-f_","greenBtn":"styles--greenBtn--37MfX","fixedCourse":"styles--fixedCourse--3C7mE"};